import { OurAggregated } from '@/src/dataRequest/ourAggregated.js';
import { skillsManTemplate } from '@/Template/skills_man_template/skills_man_template.js';
import { globalObjects } from '@/src/dataRequest/mainScript.js';
import fetchToTemplateService from '@/src/dataRequest/fetchToTemplateService';

export let vehicleDashboard_template = {
  SUMM_AREA_ID: 'section-reports',
  Report: {},
  isConsoleLog: false, 
  ourAggregated: new OurAggregated(skillsManTemplate), 

  onclick: function (event) {
    this.submit();
  },

  submit: function (form_desc, groupBy,callback) {
    this.Report.groupBy = groupBy;
    let button = document.getElementById(
      'vehicleDashboard-template-setting-window-get-template-button',
    );
    let targetSpan = getNeighborByClass_helper(button, 'target-show-span');

    infoShowText_helper(
      targetSpan,
      'Обсчет данных для получения отчета',
      // this.SUMM_AREA_ID,
    );

    vehicleDashboard_template.Report.begin = +form_desc['beginTime'];
    vehicleDashboard_template.Report.end = +form_desc['endTime'];

    // vehicleDashboard_template.getReportSettings();

    vehicleDashboard_template.requestData(form_desc, callback);
  },

  requestData(form_desc, callback) {
    // test                                                                                                                                                                                              │
    // form_desc.beginTime = 1757959200000;
    // form_desc.endTime = 1758045600000;
    // form_desc.objects = ['51937', '52959'];
    // console.log('form_desc', form_desc);

    fetchToTemplateService({
      templateName: 'vehicle_dashboard',
      form_desc,
      options: {
        option: 1,
        type: vehicleDashboard_template.Report.groupBy,
        buttonId: 'vehicle-dashboard-get-template-button-test',
      },
      areaId: 'section-violations',
      successCallback: callback,
      VueLoadingProcess: globalObjects.nodeSettings?.VueLoadingProcess || (() => {}),
      VueErrorHandler: globalObjects.nodeSettings?.VueErrorHandler || (() => {}),
      errorCallback: () =>
        vehicleDashboard_template.ourAggregated.callOurAggregated({
            option: 1,
            templateName: 'vehicle_dashboard',
            form_desc,
            areaId: 'section-violations',
            type: vehicleDashboard_template.Report.groupBy,
            callback,
            buttonId: 'vehicle-dashboard-get-template-button-test',
            // Передаём обработчики из глобального объекта
            VueLoadingProcess: globalObjects.nodeSettings?.VueLoadingProcess || (() => {}),
            VueErrorHandler: globalObjects.nodeSettings?.VueErrorHandler || (() => {}),
        }),
    });

    // vehicleDashboard_template.ourAggregated.callOurAggregated({
    //   option: 1,
    //   templateName: 'vehicle_dashboard',
    //   form_desc,
    //   areaId: 'section-violations',
    //   type: vehicleDashboard_template.Report.groupBy,
    //   callback,
    //   buttonId: 'vehicle-dashboard-get-template-button-test',
    //   // Передаём обработчики из глобального объекта
    //   VueLoadingProcess: globalObjects.nodeSettings?.VueLoadingProcess || (() => {}),
    //   VueErrorHandler: globalObjects.nodeSettings?.VueErrorHandler || (() => {}),
    // });
  },

  // getReportSettings: function () {
  //   this.Report.groupBy = document.getElementById('groupByy').value;
  // },
};